// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { StyleSheet } from 'react-native';

import { GAME_COL_WIDTH, PLAYER_COL_WIDTH, TOTAL_COL_WIDTH } from './utils';

export const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    padding: 14,
    gap: 8,
    paddingBottom: 40,
  },
  headerCard: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    marginTop: 140,
    borderRadius: 12,
    borderWidth: 2,
    borderColor: '#6b4f3a',
    backgroundColor: 'rgba(236, 224, 203, 0.6)',
    padding: 10,
  },
  headerImage: {
    width: 100,
    height: 100,
    borderRadius: 12,
  },
  headerImagePlaceholder: {
    width: 100,
    height: 100,
    borderRadius: 12,
    backgroundColor: 'rgba(20, 18, 16, 0.2)',
    borderWidth: 1,
    borderColor: '#6b4f3a',
  },
  headerText: {
    flex: 1,
    backgroundColor: 'transparent',
  },
  background: {
    flex: 1,
  },
  backgroundImage: {
    width: '100%',
    height: '110%',
    transform: [{ translateY: -50 }],
  },
  banner: {
    borderRadius: 12,
    backgroundColor: 'rgba(236, 224, 203, 0.6)',
    borderWidth: 2,
    borderColor: '#6b4f3a',
    padding: 12,
  },
  bannerTitle: {
    fontSize: 20,
    fontWeight: '800',
    color: '#2b1a12',
    letterSpacing: 0.6,
    fontFamily: 'Playball',
  },
  bannerMeta: {
    color: '#5a4636',
    marginTop: 2,
    fontFamily: 'Playball',
  },
  meta: {
    color: '#6b7280',
    fontFamily: 'Playball',
  },
  error: {
    color: '#ff8c8c',
    fontFamily: 'Playball',
  },
  tableCard: {
    borderRadius: 12,
    borderWidth: 2,
    borderColor: '#6b4f3a',
    backgroundColor: 'rgba(245, 235, 220, 0.6)',
  },
  tableHeaderRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 10,
    paddingTop: 8,
    backgroundColor: 'transparent',
  },
  resultsButtonRow: {
    flexDirection: 'row',
    gap: 12,
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  tableHeaderTitle: {
    fontSize: 12,
    color: '#2b1a12',
    fontFamily: 'Playball',
  },
  resultsButton: {
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 12,
    backgroundColor: 'rgba(241, 231, 214, 0.8)',
  },
  resultsButtonText: {
    fontSize: 12,
    color: '#2b1a12',
    fontFamily: 'Playball',
    textDecorationLine: 'none',
  },
  roundsCard: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#6b4f3a',
    backgroundColor: 'rgba(20, 18, 16, 0.35)',
    padding: 8,
    marginTop: -5,
    alignSelf: 'center',
  },
  roundsTitle: {
    fontSize: 11,
    fontFamily: 'Playball',
    color: '#f6d98a',
    marginBottom: 6,
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    textShadowColor: 'rgba(0,0,0,0.55)',
    textShadowOffset: { width: 0, height: 2 },
    textShadowRadius: 3,
  },
  roundLegendRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 8,
    backgroundColor: 'rgba(20, 18, 16, 0.25)',
    borderRadius: 8,
    padding: 6,
  },
  roundLegendLabel: {
    fontSize: 11,
    color: '#f6d98a',
    fontFamily: 'Playball',
    textShadowColor: 'rgba(0,0,0,0.55)',
    textShadowOffset: { width: 0, height: 2 },
    textShadowRadius: 3,
  },
  roundLegend: {
    gap: 4,
    backgroundColor: 'transparent',
  },
  roundLegendText: {
    fontSize: 11,
    color: '#f6d98a',
    fontFamily: 'Playball',
    textShadowColor: 'rgba(0,0,0,0.55)',
    textShadowOffset: { width: 0, height: 2 },
    textShadowRadius: 3,
  },
  table: {
    paddingVertical: 6,
    marginLeft: 10,
    marginBottom: 12,
  },
  tableHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(241, 231, 214, 0.45)',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  subHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(241, 231, 214, 0.45)',
  },
  tableRow: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(245, 235, 220, 0.45)',
  },
  rowEven: {
    backgroundColor: 'rgba(245, 235, 220, 0.45)',
  },
  rowOdd: {
    backgroundColor: 'rgba(241, 229, 210, 0.45)',
  },
  cell: {
    paddingVertical: 6,
    paddingHorizontal: 4,
    borderWidth: 1,
    borderColor: 'rgba(107, 79, 58, 0.6)',
    fontSize: 11,
    textAlign: 'center',
    color: '#120a05',
    fontFamily: 'Playball',
    backgroundColor: 'transparent',
  },
  playerCell: {
    width: PLAYER_COL_WIDTH,
    textAlign: 'left',
    fontWeight: '600',
    fontSize: 14,
    fontFamily: 'Playball',
  },
  gameCell: {
    width: GAME_COL_WIDTH,
    fontSize: 10,
    textTransform: 'uppercase',
    fontFamily: 'Playball',
  },
  totalCell: {
    width: TOTAL_COL_WIDTH,
    fontWeight: '900',
    fontSize: 13,
    color: '#2a1a10',
    textShadowColor: 'rgba(0, 0, 0, 0.35)',
    textShadowOffset: { width: 0, height: 1 },
    textShadowRadius: 2,
    fontFamily: 'Playball',
  },
  totalCellHeader: {
    backgroundColor: 'rgba(214, 178, 135, 0.45)',
  },
  playerHeaderCell: {
    backgroundColor: 'rgba(214, 178, 135, 0.45)',
  },
  gameHeaderCell: {
    borderWidth: 1,
    borderColor: 'rgba(107, 79, 58, 0.6)',
    paddingVertical: 6,
    paddingHorizontal: 4,
    backgroundColor: 'rgba(214, 178, 135, 0.35)',
  },
  gameHeaderText: {
    fontSize: 11,
    textAlign: 'center',
    color: '#2b1a12',
    fontFamily: 'Playball',
  },
  roundHeaderCell: {
    backgroundColor: 'rgba(214, 178, 135, 0.2)',
  },
  roundNumberText: {
    fontSize: 10,
    color: '#2b1a12',
    fontWeight: '600',
  },
  roundCell: {
    width: GAME_COL_WIDTH,
  },
  gameRoundsRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  resultCell: {
    backgroundColor: 'transparent',
  },
  resultText: {
    color: '#2b1a12',
    fontSize: 14,
  },
  roundsCardTitle: {
    fontSize: 14,
    fontWeight: '700',
    marginBottom: 6,
  },
  roundRowLabel: {
    color: '#6b7280',
  },
  roundsSummary: {
    marginTop: 4,
    color: '#6b7280',
  },
  summaryList: {
    marginTop: 4,
  },
  summaryItem: {
    fontSize: 12,
    color: '#6b7280',
  },
  graphWrap: {
    paddingVertical: 6,
    gap: 12,
  },
  graphLegend: {
    gap: 6,
  },
  legendItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  legendSwatch: {
    width: 12,
    height: 12,
    borderRadius: 6,
  },
  legendLabel: {
    color: '#f8fafc',
    fontSize: 12,
  },
  modalBackdrop: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.6)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
  },
  modalCard: {
    width: '100%',
    maxWidth: 520,
    borderRadius: 16,
    padding: 16,
    backgroundColor: '#17203a',
    gap: 12,
  },
  modalTableCard: {
    maxWidth: 700,
  },
  modalTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: '#f8fafc',
  },
  modalError: {
    color: '#fca5a5',
  },
  modalButtonRow: {
    flexDirection: 'row',
    gap: 8,
    justifyContent: 'flex-end',
  },
  modalSecondaryButton: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 12,
    backgroundColor: '#334155',
  },
  modalSecondaryText: {
    color: '#f8fafc',
  },
  modalCloseButton: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 12,
    backgroundColor: '#22c55e',
  },
  modalCloseText: {
    color: '#0f172a',
    fontWeight: '600',
  },
  resultsTableRoundHeaderRow: {
    flexDirection: 'row',
    backgroundColor: 'rgba(148, 120, 90, 0.65)',
  },
  resultsTableRoundHeaderCell: {
    paddingVertical: 6,
    borderWidth: 1,
    borderColor: 'rgba(107, 79, 58, 0.6)',
    alignItems: 'center',
  },
  resultsTableRoundHeaderText: {
    color: '#f8fafc',
    fontSize: 11,
  },
  resultsTableHeaderRow: {
    flexDirection: 'row',
    backgroundColor: 'rgba(107, 79, 58, 0.6)',
  },
  resultsTableRow: {
    flexDirection: 'row',
    backgroundColor: 'rgba(245, 235, 220, 0.55)',
  },
  resultsTableCell: {
    paddingVertical: 6,
    paddingHorizontal: 4,
    borderWidth: 1,
    borderColor: 'rgba(107, 79, 58, 0.6)',
    fontSize: 14,
    color: '#2b1a12',
    textAlign: 'center',
    minWidth: 40,
  },
  resultsTablePlayerCell: {
    width: 120,
    textAlign: 'left',
  },
  resultsTableHoleCell: {
    minWidth: 40,
  },
});
